import styled from 'styled-components'

import { darkBlue, grey } from '../../../../../styles/settings/colors'
import { txt14OpenSans, txt16OpenSans } from 'styles/settings/types'

export const Wrapper = styled.div`
  position: relative;

  ul {
    left: 0px;
    top: 60px;
    width: 200px;

    max-height: 240px;
    overflow: auto;

    &::-webkit-scrollbar-track {
      border-radius: 16px;
      background-color: #f1f1f7;
    }

    &::-webkit-scrollbar {
      width: 12px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 8px;
      background-color: ${grey};
    }
  }
`

export const Select = styled.button`
  ${txt14OpenSans};
  color: ${darkBlue};
  font-weight: 700;

  height: 100%;
  min-width: 200px;
  border: none;
  border-bottom: 1px solid #e2e1eb;

  display: flex;
  align-items: center;

  cursor: pointer;

  svg {
    margin-left: auto;
    margin-right: 6px;
  }
`

export const ItemWrapper = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style: none;

  width: 100%;
  padding: 16px;
`

export const Text = styled.p`
  ${txt16OpenSans};
  color: ${darkBlue};
  line-height: 24px;

  margin: 0;
  cursor: pointer;
`

export const Delete = styled.span`
  cursor: pointer;
`

export const dropdownArrow = `
    stroke: ${grey}; height: 10px; width: 15px;
`



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatement/FilterByIdentifier/SelectPlateFilterSelection/styles.js